import { createSlice } from "@reduxjs/toolkit";
import { SUNDAY, MONDAY, TUESDAY } from "../../constants/days";
import {
  normalizeDayKey,
  normalizeDoctorAvailableDaysDTO,
} from "../../utils/appointmentDayUtils";

const initialState = {
  list: [],
  isLoaded: false,
  selected: {},
  generated: {
    prev: { id: null, day: SUNDAY, availableTimes: [] },
    curr: { id: null, day: MONDAY, availableTimes: [] },
    next: { id: null, day: TUESDAY, availableTimes: [] },
  },
};

const availableAppointmentDay = createSlice({
  name: "availableDay",
  initialState,
  reducers: {
    setIsLoaded: (state, { payload }) => {
      state.isLoaded = payload;
    },
    setAvailableAppointmentDay: (state, { payload }) => {
      state.list = [normalizeDoctorAvailableDaysDTO(payload)];
      state.isLoaded = true;
    },
    addAvailableAppointmentDayToList: (state, { payload }) => {
      const normalized = normalizeDoctorAvailableDaysDTO(payload);
      const filtered = state.list.filter(
        (item) => String(item.doctorId) !== String(normalized.doctorId)
      );
      state.list = [...filtered, normalized];
    },
    updateAvailableAppointmentDayList: (state, { payload }) => {
      state.list = state.list.map((item) =>
        item.id === payload.id ? payload : item
      );
    },

    removeAvailableAppointmentDayFromList: (state, { payload }) => {
      state.list = state.list.map((doctorRecord) => {
        if (!doctorRecord?.days?.length) return doctorRecord;
        return {
          ...doctorRecord,
          days: doctorRecord.days.filter((day) => day.id !== payload.id),
        };
      });
    },
    setSelectedAvailableAppointmentDay: (state, { payload }) => {
      state.selected = payload;
      console.log('[availableAppointmentDaySlices] Payload:', payload);
    },
    clearSelectedAvailaleAppointmentDay: (state, { payload }) => {
      state.selected = {};
    },
    /* yeni eklenen kısım*/
    setGeneratedAvailableAppointmentDay: (state, { payload }) => {
      state.generated = payload;
    },
    clearGeneratedAvailableApoointmentDay: (state, { payload }) => {
      state.generated = {
        prev: {
          ...payload.prev,
          availableTimes: [],
        },
        curr: {
          ...payload.curr,
          availableTimes: [],
        },
        next: {
          ...payload.next,
          availableTimes: [],
        },
      };
    },
    /* alt taraf silinecek */
    setRenderedAvailableAppointmentDay: (state, { payload }) => {
      state.rendered = payload;
    },
    clearRenderedAvailableAppointmentDay: (state, { payload }) => {
      state.rendered = {
        prev: { ...payload.prev, availableTimes: [] },
        curr: { ...payload.curr, availableTimes: [] },
        next: { ...payload.next, availableTimes: [] },
      };
    },
    removeTimeFromGeneratedAvailableAppointmentDay: (state, { payload }) => {
      if (payload.index === -1) {
        let prev = state.generated.prev.availableTimes.filter(
          (x) => x.hour !== payload.hour
        );
        state.generated = {
          ...state.generated,
          prev: { ...state.generated.prev, availableTimes: prev },
        };
      } else if (payload.index === 0) {
        let curr = state.generated.curr.availableTimes.filter(
          (x) => x.hour !== payload.hour
        );
        state.generated = {
          ...state.generated,
          curr: { ...state.generated.curr, availableTimes: curr },
        };
      } else if (payload.index === 1) {
        let next = state.generated.next.availableTimes.filter(
          (x) => x.hour !== payload.hour
        );
        state.generated = {
          ...state.generated,
          next: { ...state.generated.next, availableTimes: next },
        };
      }
    },
    addAvailableAppointmentDayByDoctorId: (state, { payload }) => {
      const dayKey = normalizeDayKey(payload.data.day);
      const dayEntry = {
        id: payload.data.id,
        day: dayKey,
        availableTimes: payload.data.availableTimes || [],
      };

      const doctorIndex = state.list.findIndex(
        (x) => String(x.doctorId) === String(payload.doctorId)
      );

      if (doctorIndex === -1) {
        state.list.push({
          doctorId: payload.doctorId,
          days: [dayEntry],
        });
        return;
      }

      const doctorRecord = { ...state.list[doctorIndex] };
      const days = Array.isArray(doctorRecord.days) ? [...doctorRecord.days] : [];
      const existingIndex = days.findIndex(
        (d) => normalizeDayKey(d.day) === dayKey
      );

      if (existingIndex >= 0) {
        days[existingIndex] = {
          ...dayEntry,
          id: dayEntry.id || days[existingIndex].id,
        };
      } else {
        days.push(dayEntry);
      }

      doctorRecord.days = days;
      state.list[doctorIndex] = doctorRecord;
    },
    updatedAvailableAppointmentDayByDoctorId: (state, { payload }) => {
      const doctorIndex = state.list.findIndex(
        (x) => String(x.doctorId) === String(payload.doctorId)
      );
      if (doctorIndex === -1) return;

      const dayKey = normalizeDayKey(payload.data.day);
      const doctorRecord = { ...state.list[doctorIndex] };
      const days = Array.isArray(doctorRecord.days) ? [...doctorRecord.days] : [];
      const existingIndex = days.findIndex(
        (d) => normalizeDayKey(d.day) === dayKey
      );

      const dayEntry = {
        ...payload.data,
        day: dayKey,
        availableTimes: payload.data.availableTimes || [],
      };

      if (existingIndex >= 0) {
        days[existingIndex] = {
          ...dayEntry,
          id: dayEntry.id || days[existingIndex].id,
        };
      } else {
        days.push(dayEntry);
      }

      doctorRecord.days = days;
      state.list[doctorIndex] = doctorRecord;
    },
  },
});

export const {
  /**yeni eklenen */
  setIsLoaded,
  setGeneratedAvailableAppointmentDay,
  clearGeneratedAvailableApoointmentDay,
  addAvailableAppointmentDayByDoctorId,
  updatedAvailableAppointmentDayByDoctorId,
  removeTimeFromGeneratedAvailableAppointmentDay,
  /**-------------------- */
  setAvailableAppointmentDay,
  addAvailableAppointmentDayToList,
  updateAvailableAppointmentDayList,
  removeAvailableAppointmentDayFromList,
  setSelectedAvailableAppointmentDay,
  clearSelectedAvailaleAppointmentDay,
} = availableAppointmentDay.actions;
export default availableAppointmentDay.reducer;
